import React, {useState} from "react";
import Header from "./Header";
import Footer from "./Footer";
import AppointmentBookingForm from "./AppointmentBookingForm";
import VerticalContactBar from "./VerticalContactBar";
import { useNavigate, Link } from "react-router-dom";

const Layout = ({children}) =>{

    const [showappointmentmodal, setShowAppointmentModal] = useState(false);

    const handleAppointmentModelOpen = () =>{
        setShowAppointmentModal(true);
    }
    const handleAppointmentModelClose = () =>{
        setShowAppointmentModal(false);
    }

    //const callingno = "+919871150032";
    const callingno = "+919289861631";
    const whatsapp = "+919289861631";
    const whatsappurl = `https://wa.me/${whatsapp}?text=${encodeURIComponent("Hi, I am contacting regarding an enquiry.")}`;

    return(
    <>
        <Header onApBookNow={handleAppointmentModelOpen} />
        <div className="fullrootdocument">
            <main>{children}</main>
        </div>

        <AppointmentBookingForm showApModal={showappointmentmodal} onApBookClose={handleAppointmentModelClose} />
        
        <div className="vcb-container" aria-hidden={showappointmentmodal ? "true" : "false"}>
            <div class="social-share">
                <Link to={`tel:${callingno}`} class="icon ">
                    <i class="fa-solid fa-phone me-4"></i>Call now
                </Link>
                <Link to={whatsappurl} class="icon" target="_blank">
                    <i class="fa-brands fa-whatsapp me-4"></i>Connect us
                </Link>
                <button type="button" class="icon" onClick={handleAppointmentModelOpen} aria-label="Open enquiry form">
                    <i className="fa-solid fa-headset me-4"></i>Enquire now
                </button>
            </div>
        </div>
    </>
    );
}

export default Layout;